export default "__VITE_ASSET__274e27d2__"